module.exports = {
      id: "offer-menu-right-arrow-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#offer-menu-right-arrow",
      toString: function () {
        return this.url;
      }
    }